<template>
  <div id="commonWrapper" class="commonSearchWrapper">
    <div class="clearfix" v-if="customs && customs.length > 0">
      <div class="screenCon" v-for="(custom_item, index) in customs" :key="'index_' + index">
        <div class="screenHead info-txt" :style="{ width: txtWidth }">
          {{ custom_item.name }}
        </div>
        <el-input v-if="custom_item.type == 'input'" v-model="custom_item.activeCode"
          :placeholder="headPlaceholder(custom_item.type)" @keyup.enter.native="commonSearch" size="medium"
          :type="custom_item.inputType || 'text'" style="width: 160px;" clearable></el-input>
        <el-select v-if="custom_item.type == 'select'" v-model="custom_item.activeCode" size="medium"
          style="width: 160px;" :clearable="!custom_item.clearable ? false : true"
          :filterable="custom_item.filterable ? custom_item.filterable : false"
          :placeholder="headPlaceholder(custom_item.type)">
          <el-option v-if="custom_item.item && custom_item.item.length > 0"
            v-for=" (child, child_index) in custom_item.item" :label="child.label" :value="child.value"
            :key="child_index"></el-option>
        </el-select>
        <el-select v-if="custom_item.type == 'multipleSelect'" v-model="custom_item.activeCode" size="medium" clearable
          :filterable="custom_item.filterable ? custom_item.filterable : false"
          :filter-method="((value) => { filterMethodFn(value, custom_item, index) })"
          :collapse-tags="custom_item.collapseTags ? true : false" multiple
          :placeholder="headPlaceholder(custom_item.type)" style="width: 220px;">
          <el-option v-if="custom_item.item.length > 0" v-for=" (child, child_index) in list[index]"
            :label="child.label" :value="child.value" :key="child_index"></el-option>
        </el-select>
        <el-date-picker v-if="custom_item.type == 'timeRange'" v-model="custom_item.activeCode" type="daterange"
          format="dd/MM/yyyy" value-format="dd/MM/yyyy" range-separator="-" :clearable="custom_item.clearable"
          :start-placeholder="$t('common.startdate')" :end-placeholder="$t('common.enddate')"
          size="medium"></el-date-picker>
      </div>
      <span class="footer">
        <el-button size="small" type="primary" @click="commonSearch()">{{ $t('common.search') }}</el-button>
        <el-button size="small" v-show="showResetBtn" class="sys-btn-default" @click="clickReset()">{{
      $t('common.reset')
          }}</el-button>
      </span>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  data() {
    return {
      input: '',
      value: '',
      list: [],
      customs: this.custom
    }
  },
  props: {
    custom: {
      type: Array,
      default: () => [],
    },
    txtWidth: '',
    showResetBtn: {
      type: Boolean,
      default: true,
    },
    filterMethod: {
      type: Function,
      default: () => {
      }
    }
  },
  mounted() {
    this.list = new Array(this.customs.length).fill([]);
  },
  methods: {
    filterMethodFn(query, custom_item, index) {
      if (custom_item.item.length == 0) {
        return
      }
      let arr = custom_item.item.filter(obj => {
        return obj.label.includes(query);
      });
      if (arr.length > 200) {
        this.list[index] = arr.slice(0, 200);
      } else {
        this.list[index] = arr;
      }
      this.$forceUpdate()
    },
    clickReset() {
      if (this.custom && this.custom.length > 0) {
        for (let i in this.custom) {
          if (this.custom[i].type == 'multipleSelect') {
            this.custom[i].activeCode = []
          } else if (this.custom[i].type == 'select') {
            this.custom[i].activeCode = null;
          } else {
            this.custom[i].activeCode = '';
          }
        }
      }
      this.commonSearch();
      this.$emit('reset')
    },

    commonSearch() {
      this.$emit('commonSearch-Click', this.custom)
    },
    inputVal(val) {

    },
    headPlaceholder(type) {
      let placeholder = ''
      if (type === 'input') {
        placeholder = vm.$t('common.inputplaceholder');
      } else if (['select', 'multipleSelect'].includes(type)) {
        placeholder = vm.$t('common.selectplaceholder');
      }
      return placeholder
    },
  },
  components: {},
  watch: {
    custom: {
      handler(newVal, oldVal) {

        this.$nextTick(() => {
          this.customs = newVal
          for (let i = 0; i < newVal.length; i++) {
            if (newVal[i].type === 'select' || newVal[i].type === 'multipleSelect') {
              if (newVal[i].item.length > 0) {
                this.filterMethodFn('', newVal[i], i)
              }
            }
          }
        })
      }, deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.commonSearchWrapper {
  margin: 0 0 20px 0;
  border-bottom: 1px solid #e9edf3;

  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 220px;
  }

  .clearfix {
    clear: both;
  }

  .screenCon {
    margin-right: 20px;
    margin-bottom: 20px;
    display: inline-block;

    &:nth-child(3) {
      margin-right: 0;
    }
  }

  .screenCon:last-of-type {
    margin-right: 0;
  }

  .screenHead {
    float: left;
    text-align: right;
    font-size: 13px;
    color: #5B647D;
    line-height: 36px;
    margin-right: 5px;
  }

  .footer {
    display: inline-block;
    margin-left: 20px;
    margin-bottom: 20px;
  }

  .el-date-editor .el-range-separator {
    width: 7%;
  }
}
</style>
